import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "onClick", "trackingValue", "description", "illustrationName", "children"];
import { useCallback } from 'react';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import SelectableButtonLink from '../../components/internal/SelectableButtonLink';
import { GUIDANCE_IMAGE_HEIGHT_PX } from '../../constants';
import { useTrackingContext } from '../../context/TrackingContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BaseSelectableButton = _ref => {
  let {
      title,
      onClick,
      trackingValue,
      description,
      illustrationName,
      children
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackUserInteraction
  } = useTrackingContext();
  const onClickHandler = useCallback(evt => {
    onClick === null || onClick === void 0 || onClick(evt);
    trackUserInteraction('EmptyState: Click Modal CTA', {
      value: trackingValue
    });
  }, [onClick, trackingValue, trackUserInteraction]);
  return /*#__PURE__*/_jsx(SelectableButtonLink, Object.assign({
    onClick: onClickHandler,
    underline: false,
    use: "unstyled"
  }, otherProps, {
    children: /*#__PURE__*/_jsxs(SelectableButton, {
      size: "large",
      block: true,
      title: title,
      description: description,
      children: [children, /*#__PURE__*/_jsx(Illustration, {
        name: illustrationName,
        height: GUIDANCE_IMAGE_HEIGHT_PX,
        marginBlockStart: "300"
      })]
    })
  }));
};
export default BaseSelectableButton;